module.exports = __webpack_public_path__ + "img/p4.5b6ad355.png";